import { UPDATE_USERS } from "Redux/Actions/usersActions";

const INITIAL_STATE = {
  usersData: [],
};

const usersReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case UPDATE_USERS: {
      return {
        ...state,
        ...action.value,
      };
    }
    default:
      return state;
  }
};

export default usersReducer;
